module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/tourist-c2f3de85133cb41b3fb98dcd72d962ef.png";